import { IconButton, MENU_PANEL_CLASSES } from "@controls";
import { ListFilter } from "@icons";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import FilterMenuContent from "./menu";
import { FilterMenuItem } from "./menu/types";
import { useFilterState } from "./use-filter-state";

interface TableFilterPopoverProps {
  filterMenuItemGroups: FilterMenuItem[][];
}

export default function TableFilterPopover({
  filterMenuItemGroups,
}: TableFilterPopoverProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const {
    selectedValues,
    comparisonValues,
    booleanValues,
    handleSelectionChange,
    handleComparisonChange,
    handleBooleanChange,
    compoundGroups,
    addCompoundGroup,
  } = useFilterState(filterMenuItemGroups);

  return (
    <DropdownMenu.Root open={open} onOpenChange={setOpen}>
      <DropdownMenu.Trigger asChild>
        <IconButton
          size="sm"
          icon={<ListFilter />}
          aria-label={t("filterTable")}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className={`${MENU_PANEL_CLASSES} min-w-72`}
          sideOffset={6}
          align="start"
          side="bottom"
        >
          <FilterMenuContent
            selectedValues={selectedValues}
            comparisonValues={comparisonValues}
            booleanValues={booleanValues}
            onSelectionChange={handleSelectionChange}
            onComparisonChange={handleComparisonChange}
            onBooleanChange={handleBooleanChange}
            filterMenuItemGroups={filterMenuItemGroups}
            onCreateCompoundGroup={addCompoundGroup}
            existingCompoundLogics={compoundGroups.map((g) => g.logic)}
          />
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
